import { getAmplitudeClient } from '../Qualifications/RequirementsWidget/amplitude';
import { DispatchCriterion } from '../utils/dispatchSettingsApi';

export const SMART_DISPATCHED_WORK_ORDER = 'Smart Dispatched Work Order';

// Maps dispatch-automation criteria type enums to buyer-facing filter names.
// Mirrors CRITERIA_FILTER_NAMES in the ui repo (AssignedDrawer/utils.js).
const CRITERIA_FILTER_NAMES: Record<string, string> = {
    MAX_DISTANCE_MILES: 'Distance',
    MIN_BACKGROUND_CHECK_AGE: 'Background Check Age',
    MIN_DRUG_SCREEN_AGE: 'Drug Screen Age',
    MIN_MP_PSS_TIER: 'PSS Score',
    MAX_ASSIGNMENTS_PER_DAY: 'Assignments Per Day',
    MIN_WO_COMPLETED: 'Work Orders Completed',
    MIN_WO_COMPLETED_COMPANY: 'Work Orders Completed (Company)',
    MIN_WO_COMPLETED_PROJECT: 'Work Orders Completed (Project)',
    MIN_WO_COMPLETED_CLIENT: 'Work Orders Completed (Client)',
    REQUIRED_CREDENTIALS: 'Required Credentials',
    REQUIRED_EQUIPMENT: 'Required Equipment',
};

export const mapCriteriaToFilterNames = (criteria: DispatchCriterion[] = []): string[] => criteria
    .map(c => CRITERIA_FILTER_NAMES[c.criteriaType] || c.criteriaType)
    .filter(Boolean);

export const trackEvent = (eventName: string, properties: Record<string, unknown>): void => {
    try {
        const client = getAmplitudeClient();
        if (client) {
            client.logEvent(eventName, properties);
        }
    } catch { /* never block on tracking failure */ }
};
